import { Button, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { Project } from '../../Projects/projects';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/Store';
import { projectSlice } from '../../../redux/ProjectSlice';

interface DeleteProjectDialogProps {
  onClose: () => void;
}

const DeleteProjectDialog = ({ onClose }: DeleteProjectDialogProps) => {
  const dispatch = useDispatch();

  const { isMultiSelect, selectedProjects } = useSelector((state: RootState) => state.project.projectSelect);
  const selectedProjectsLength = selectedProjects.length;

  const handleDeleteSelected = () => {
    selectedProjects.forEach((project: Project) => {
      dispatch(projectSlice.actions.onDeleteProject({ id: project.id }));
    });
    dispatch(projectSlice.actions.onChangeMultiSelect(false));
    dispatch(projectSlice.actions.onSelectProjects([]));
    onClose();
  };

  const handleCancelDelete = () => {
    onClose();
  };

  return (
    <>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="deleteProjectDialog.title">Warning</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="dialogTitle">
            {isMultiSelect && selectedProjectsLength ? (
              <Trans i18nKey="deleteProjectDialog.multipleProjectText">You&apos;re about to delete {{ selectedProjectsLength }} projects</Trans>
            ) : (
              <Trans i18nKey="deleteProjectDialog.singleProjectText">You&apos;re about to delete a project</Trans>
            )}
          </Typography>
          <Typography>
            {isMultiSelect && selectedProjectsLength ? (
              <Trans i18nKey="deleteProjectDialog.multipleProjectText2">
                Are you sure you want to delete these projects? This action can not be undone.
              </Trans>
            ) : (
              <Trans i18nKey="deleteProjectDialog.singleProjectText2">
                Are you sure you want to delete this project? This action can not be undone.
              </Trans>
            )}
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ justifyContent: 'center', margin: '2px 0' }}>
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button variant="text" autoFocus onClick={handleCancelDelete}>
            <Trans i18nKey="deleteProjectDialog.button.cancel">Cancel</Trans>
          </Button>
          <Button variant="contained" autoFocus onClick={handleDeleteSelected}>
            <Trans i18nKey="deleteProjectDialog.button.confirm">Confirm</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};

export default DeleteProjectDialog;
